<template>
  <b-container class="p-0 profile-container" fluid>
    <b-row no-gutters>
      <b-col cols="2"
        ><div>
          <b-img
            class="profile-picture"
            :src="userInfo.profile_picture"
            alt
          /></div
      ></b-col>
      <b-col cols="8"
        ><div class="ml-2">
          <h2 class="bigName">
            {{ userInfo.user.first_name }} {{ userInfo.user.last_name }}
          </h2>
          <p class="big-work-info">{{ userInfo.job_title }}</p>
          <router-link
            :to="{
              name: 'companyProfile',
              params: { companyId: getId(userInfo.company) },
            }"
          >
            <p class="big-profile-text">{{ userInfo.company_name }}</p>
          </router-link>
        </div></b-col
      >
      <b-col cols="2"
        ><div class="mt-2">
          <b-button
            class="go-to-profile-btn"
            @click="
              () => {
                $router.push({
                  name: 'userProfilePage',
                  params: { customerId: $route.params.customerId },
                });
              }
            "
            >profile</b-button
          ><b-button
            v-if="
              userInfo.follow_status &&
              !!userInfo.follow_status.following === false
            "
            class="other-profile-follow-btn"
            variant="info"
            @click="followReq"
          >
            <i class="far fa-eye"></i>
          </b-button>
          <b-button
            class="other-profile-follow-btn"
            variant="info"
            v-if="
              userInfo.follow_status &&
              !!userInfo.follow_status.following === true
            "
            v-on:click="UnFollowReq"
          >
            <i class="far fa-eye-slash"></i>
          </b-button></div
      ></b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="actions">
        <b-button class="profile-action-btn " @click="sendMsg">
          <i class="far fa-envelope profile-message-icon"></i>
          Message </b-button
        ><b-button
          class="profile-action-btn"
          v-if="
            userInfo.friendship_status &&
            userInfo.friendship_status.status === ''
          "
          @click="toNetwork()"
        >
          <i class="fas fa-user-plus profile-follow-icon"></i>
          Add to Network
        </b-button>
        <b-button
          class="profile-action-btn"
          v-if="
            userInfo.friendship_status &&
            userInfo.friendship_status.status === 'sent request'
          "
        >
          <i class="fas fa-users profile-follow-icon"></i>
          Request sent
        </b-button>
        <b-button
          class="profile-action-btn"
          v-if="
            userInfo.friendship_status &&
            userInfo.friendship_status.status === 'pending request or you'
          "
        >
          <i class="fas fa-users profile-follow-icon"></i>
          Sent you request
        </b-button>
        <b-button
          class="profile-action-btn Unfriend"
          v-if="
            userInfo.friendship_status &&
            userInfo.friendship_status.status === 'friend'
          "
        >
          <i class="fas fa-user-times profile-follow-icon"></i>
          Unfriend
        </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row
      ><div class="profile-segments-div">
        <b-badge
          v-for="segment in userInfo.tags"
          :key="segment.id"
          class="profile-segment"
          variant="dark"
          >{{ segment.name }}</b-badge
        >
      </div>
    </b-row>

    <b-modal
      v-model="congratulationModalShow"
      size="md"
      hide-footer
      @click="
        congratulationModalShow = false;
        networkModalText = '';
      "
    >
      <h3 style="text-align: center">CONGRATULATIONS!</h3>
      <p style="text-align: center">{{ networkModalText }}</p>
      <div class="congratulationModal">
        <router-link :to="{ name: 'network' }">My Network</router-link>
        <button
          @click="
            congratulationModalShow = false;
            networkModalText = '';
          "
        >
          Continue
        </button>
      </div>
    </b-modal>
    <notifications group="profile" position="bottom left" />
  </b-container>
</template>

<script>
import OtherProfile from '../../utils/mixins/OtherProfile';

export default {
  name: 'MobileOtherProfile',
  mixins: [OtherProfile],
};
</script>
<style scoped>
.profile-container {
  background: white;
  border-radius: 10px;
}
.actions {
  margin-top: 5px;
  border-top: 1px solid #ebebeb;
  display: flex;
  justify-content: space-around;
  padding: 2px;
}
.profile-picture {
  border-radius: 10px 0 0 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.profile-segments-div {
  padding: 0 15px 0 15px;
  text-align: left;
  width: 100%;
  border-top: 1px solid #ebebeb;
}
.profile-segments-div > span {
  border-radius: 0 8px 8px 8px;
}
.profile-segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #dbdbdb;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: #7f7f7f;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.profile-message-icon,
.profile-follow-icon {
  font-size: 13.5px;
}
.go-to-profile-btn {
  background-color: #f3f3f3;
  color: #7f7f7f;
  border-radius: 0 10px 10px 10px;
  height: 28px;
  border: none;
  padding: 2px 4px;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
}
.profile-action-btn{
  background-color: #f3f3f3;
  color: #7f7f7f;
  font-size: 12px;
  text-align: center;
  height: 30px;
  border: none;
  display: block;
  border-radius: 0 10px 10px 10px;
  width: 100%;
}
.other-profile-follow-btn {
  border-radius: 0 10px 10px 10px;
  height: 28px;
  border: none;
  padding: 2px 4px;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  background-color: #bd9d5f;
  color: #fff;
}
.bigName {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 1px;
  margin-top: 5px;
  text-transform: capitalize;
}
.big-work-info {
  color: gray;
}
.big-profile-text,
.big-work-info {
  font-size: 12px;
  margin-bottom: 0rem;
  padding-bottom: 15px;
  text-transform: capitalize;
  padding: 0;
}
.big-profile-text {
  color: #bd9d5f;
}
.user-profile-hr {
  background: whitesmoke;
  margin: 0rem;
}
.Unfriend {
  background-color: #aaa !important;
}
.congratulationModal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulationModal a,
.congratulationModal button {
  color: #bd9d5f;
  background-color: #fff;
  border: 1px solid #bd9d5f;
  padding: 3px 10px;
  margin-right: 10px;
}
.congratulationModal a:hover,
.congratulationModal button:hover {
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #fff;
}
</style>
